//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import Slider from "react-slick";
import parse from 'html-react-parser';
//@end

//@import components
import PublicAppContainer from 'app_components/layouts/public'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import IconComponent from 'app_components/commons/icons'
import OffercardCommon from 'app_components/commons/offercard';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import SwitchInterestModule from 'app_components/modules/newsEvents/switchInterest';
import { Link } from 'react-router-dom';
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors';
import useWindowWidth from 'app_hooks/useWindowWidth';
// @end

// @INFO Import types
import { ILanding, ILandingTrainings } from 'app_types/admin/landings/landingTypes';
// @end

// @INFO Import services
import LandingService from 'app_services/admin/landings/landingService';
// @end

// @INFO Import Styles
import './../officialsScreen.scss'
import shortid from 'shortid';
import { customs } from 'app_config/globals';
import EditorjsService from 'app_services/editor/editorjs/editorjsService';


// @ADD Component types
interface IOfficialsScreenLayoutProps {}


const OfficialsScreenLayout: React.FC<IOfficialsScreenLayoutProps> = (props) => {

  const editorJsService: EditorjsService = new EditorjsService();
  const { t } = useTranslation()
  const [colors] = useColors()
  const { windowWidth } = useWindowWidth()

  const [trainings, updateTrainings] = useState<ILandingTrainings[]>([])
  const [landing, updateLanding] = useState<ILanding | undefined>(undefined)

  // @INFO Servicios
  const landingService = new LandingService()

  useEffect(() => {
    getLandingData()
  },[])

  const filterTrainings = (trainingList: ILandingTrainings[]) => {
    const _trainings = trainingList.reduce((accum: ILandingTrainings[], element: ILandingTrainings) => {
      if (element.status && element?.course?.extra_info) {
        accum.push(element)
      }
      return accum;
    }, [])
    updateTrainings(_trainings)
  }

  useEffect(() => {
    if (landing?.landing.trainings && landing?.landing.trainings.length > 0) {
      filterTrainings(landing?.landing.trainings)
    }
  }, [landing?.landing?.trainings])

  /**
   * @INFO Obtener la data para la landing
   */
  const getLandingData = async () => {
    let httpParams: any = {
      slug: 'officials'
    }
    const landingResponse = await landingService.fetchLandingData(httpParams)
    if (landingResponse) {
      updateLanding(landingResponse)
    }
  }

  const getNumberItems = () => {
    if(windowWidth < 576){
      return 1
    }
    if(windowWidth < 991){
      return 2
    }
    return 4
  }

  const getTrainingData = (training: ILandingTrainings) => {
    let {
      description,
      attachedFile,
      modality,
      platform_video,
      url_video,
      title,
      price,
      status
    } = training

    let link = undefined;
    if (status === false) return;
    if (!training.course?.extra_info) return;

    if (training.course?.extra_info) {
      link = `curso/${training.course.program._id}/novedad`
      description = ''
      if (training.course.extra_info?.short_description) {
        description = parse(editorJsService.jsonToHtml(training.course.extra_info?.short_description.blocks))
      }
      if (training.course.extra_info?.coverUrl) {
        attachedFile = training.course.extra_info?.coverUrl
      }
      if (
        (training.course.extra_info?.platform_video && training.course.extra_info?.platform_video !== '') &&
        (training.course.extra_info?.url_video && training.course.extra_info?.url_video !== '')
      ) {
        platform_video = training.course.extra_info?.platform_video
        url_video = training.course.extra_info?.url_video
      }
      // if (training.course.extra_info?.alternative_title && training.course.extra_info?.alternative_title !=='') {
      //   title = training.course.extra_info?.alternative_title
      // } else if (training.course.program?.name) {
        title = training.course.program?.name
      // }

      if (training.course.extra_info?.schedulingMode?.name) {
        modality = training.course.extra_info?.schedulingMode?.name
      }
    }

    return (
      <OffercardCommon
        // @ts-ignore
        course={{
          key: shortid.generate(),
          _id: shortid.generate(),
          elementType: 'training_v2',
          extra_info: {
            description: description,
            coverUrl: attachedFile,
          },
          custom_training: {
            modality: modality,
            price: price,
            video: {
              platform: platform_video,
              url: url_video
            }
          },
          program: {
            name: title,
          },
        }}
        link={link}
        share={`${customs.site}/officials`}
      />
    )
  }

  return(
    <PublicAppContainer>
      <div className='officials_screen-layout'>
        <div className="container-header-page">
        <TextComponent
            type='subtitle'
            style={{
              marginRight: 'auto'
            }}
          >
              Colaboradores
          </TextComponent>
          <div className="container-slider-header">
            {landing?.landing?.title_training && (
              <TextComponent
                type='title'
              >
                {landing?.landing?.title_training}
              </TextComponent>
            )}
            {trainings && trainings?.length > 0 ?
              <Slider
                arrows={true}
                className='slider-page'
                infinite={(trainings.length >= getNumberItems()) ? true : false}
                slidesToShow={getNumberItems()}
                nextArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleRight' width={24} color={colors.primary} />}/>}
                prevArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleLeft' width={24} color={colors.primary} />}/>}
              >
                {trainings.map((_item) => (
                  <>
                    {_item.status && (
                      <div
                        key={_item.slug}
                        className='container-offer-card-page'
                      >
                        {getTrainingData(_item)}
                      </div>
                    )}
                  </>
                ))}
              </Slider>
            :null}
          </div>
        </div>
        <div className="container-body-page">
          {/* ==================================================== */}
          {/* Herramientas */}
          {/* ==================================================== */}
          {landing?.landing?.title_page && (
            <TextComponent
              type='title'
            >
              {landing?.landing?.title_page}
            </TextComponent>
          )}
          {landing?.landing?.article && (
            <>
              {landing?.landing?.article?.coverFile && (
                <div className="container-header-img" style={{backgroundImage: `url(${landing?.landing?.article?.coverFile})`}}></div>
              )}
              {landing?.landing?.article?.coverCaption && (
                <div className="container-caption-image">
                  <IconComponent
                    svg='Clock'
                    class_name='clock-icon'
                  />
                  <TextComponent
                    type='text'
                  >
                    {landing?.landing?.article?.coverCaption}
                  </TextComponent>
                </div>
              )}
              {landing?.landing?.article?.title && (
                <TextComponent
                  type='title'
                  style={{
                    color: 'var(--primary)',
                    textTransform: 'initial'
                  }}
                >
                  {landing?.landing?.article?.title}
                </TextComponent>
              )}
              {landing?.landing?.article?.content && (
                <div className="container-article">
                  {parse(landing?.landing?.article?.content ? landing?.landing?.article?.content : '')}
                </div>
              )}
            </>
          )}
          {/* ==================================================== */}
          {/* Venta efectiva */}
          {/* ==================================================== */}
          {landing?.landing?.title_posts && (
            <TextComponent
              type='title'
            >
              {landing?.landing?.title_posts}
            </TextComponent>
          )}
          <div
            className='switch-interest-section'
          >
            <SwitchInterestModule
              only={['webinar', 'capsules', 'research', 'journal']}
              hideTitle
              hideSubtitle
              locations={['officials_landing']}
            />
          </div>
          {/* ==================================================== */}
          {/* Programación el linea */}
          {/* ==================================================== */}
          {landing?.landing?.scheduling?.length ?
            <>
              {landing?.landing?.scheduling?.length ?
                  <div
                    className='container-buttons-sheduling'
                  >
                    {landing?.landing?.scheduling.map((_schedule) => (
                      <div className="container-scheduling-item">
                        <TextComponent
                          type='title'
                          className='title-page-teachers'
                        >
                          {_schedule.title}
                        </TextComponent>
                        <Link
                          to={{
                            pathname: _schedule.attachedFile
                          }}
                          target='_blank'
                        >
                          <ButtonComponent
                            key={_schedule.unique}
                            variant='secondary'
                            style={{
                              width: 'fit-content'
                            }}
                          >
                            Descargar documento
                          </ButtonComponent>
                        </Link>
                      </div>
                    ))}
                  </div>
                :null}
            </>
          : null}
        </div>
      </div>
    </PublicAppContainer>
  )
}

// ======================================
// Flecha
// ======================================
const CustomArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      {props.icon}
    </div>
  );
}


export default OfficialsScreenLayout
